var React = require('react');

function StepCircle0948px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-4.173 32.26v-1.872c.494.026 1.066 0 1.846-.104 1.326-.156 2.574-.702 3.536-1.612 1.118-1.04 1.924-2.496 2.236-4.498h-.078c-.936 1.144-2.288 1.82-4.004 1.82-3.042 0-4.992-2.288-4.992-5.2 0-3.172 2.34-5.98 5.798-5.98s5.59 2.782 5.59 7.124c0 3.718-1.248 6.318-2.912 7.93-1.3 1.248-3.094 2.054-4.914 2.262-.832.104-1.586.156-2.106.13zm4.16-15.704h-.026c-1.924 0-3.302 1.716-3.302 4.108 0 2.106 1.274 3.588 3.25 3.588 1.534 0 2.73-.754 3.354-1.768.104-.208.182-.468.182-.832.026-2.912-1.066-5.096-3.458-5.096z"}));
}

StepCircle0948px.displayName = "StepCircle0948px";

StepCircle0948px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle0948px;

StepCircle0948px.default = StepCircle0948px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-09-48px.svg
// module id = 1160
// module chunks = 0